import ApiService from '@/services/api';

// TYPES

export type TCreateCheckoutSessionMaterials = {
  companyId: number;
  /** Number of seats to buy. Must not fall below the seats already assigned. */
  quantity: number;
};

export type TCreateCheckoutSessionResponse = {
  /** Stripe-hosted payment page to redirect the buyer to. */
  checkout_url: string;
  session_id: string;
};

export const createCheckoutSession = async ({
  companyId,
  quantity,
}: TCreateCheckoutSessionMaterials): Promise<TCreateCheckoutSessionResponse> => {
  const endpoint = `/v1/companies/${companyId}/licenses/checkout-session/`;
  const response = await ApiService.post(endpoint, { quantity });
  return response?.data;
};
